import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from '../initializer/app.routes';
import { erroresInterceptorFn } from '../errores/errores.interceptor';
import { provideAuthServices } from '../providers/auth.providers';
import { motorDeAnimaciones } from '@/app/design/patterns/animar';

export const appConfig: ApplicationConfig = {
  providers: [
    // La app nunca cargó zone.js (no está en las dependencias, no hay `polyfills` en
    // angular.json y el index.html no la inyecta). Angular 21 ya arranca zoneless por
    // defecto en ese escenario: declararlo acá no cambia el comportamiento, lo hace
    // explícito y verificable — y deja el marcador de dev que avisa si alguien vuelve a
    // meter zone.js o un `provideZoneChangeDetection()` contradictorio (AD-11).
    provideZonelessChangeDetection(),
    ...provideAuthServices(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // El interceptor que produce el error de aplicación (spine, «Consistency Conventions»:
    // «un tipo de error de aplicación con código, mensaje para humanos y acción sugerida; el
    // interceptor lo produce, la primitiva de error lo muestra»). No reemplaza el error que
    // viaja —los 65 lugares que leen `err.error.detail` siguen andando—: deja la traducción al
    // costado, y la levanta `errorDeAplicacionDe()`.
    provideHttpClient(withInterceptors([erroresInterceptorFn])),
    // `provideAnimationsAsync` y no `provideAnimations` (Historia 1.13 · AD-17): el motor de
    // animaciones son ~60 kB que hoy TODO el mundo descarga antes de ver la pantalla de login,
    // que no anima nada. Con la versión asíncrona el motor llega cuando algo lo necesita, y lo
    // que necesita animaciones —los toasts— ya aparece después del primer render.
    //
    // Y el motor lo elige la preferencia de movimiento (Historia 1.14 · NFR-10): el apagado de
    // `styles.css` es CSS y no alcanza a `@angular/animations`, que corre sobre la Web
    // Animations API. Con `'noop'` cada `trigger` salta a su estado final sin recorrido.
    provideAnimationsAsync(motorDeAnimaciones()),
    // Los toasts del mockup (`#toasts`): abajo a la derecha, apilados hacia arriba con el más
    // nuevo abajo —el mockup los agrega al final de la columna—, sin barra de progreso. Lo mismo
    // que pide cada llamada de `NotificationService`, para el aviso que salga por otro lado.
    provideToastr({
      positionClass: 'toast-bottom-right',
      newestOnTop: false,
      progressBar: false,
    }),
  ],
};
